import { useAccordionItemState } from '@chakra-ui/react';
import { BundleAccordionItemContent } from 'components/product/BundleAccordionItemContent';
import { useProductAccordionContent } from 'hooks/product/useProductAccordionContent';
import type { SanityProduct } from 'types/cms/SanityProduct';

interface BundleAccordionItemPanelProps {
  product: SanityProduct;
}

export function BundleAccordionItemPanel({
  product,
}: BundleAccordionItemPanelProps) {
  const { isOpen } = useAccordionItemState();
  const { data: accordionContent } = useProductAccordionContent(product.slug, {
    enabled: isOpen,
  });

  if (!accordionContent) return null;

  return <BundleAccordionItemContent accordionContent={accordionContent} />;
}
